import { Link as ChakraLink, Stack } from "@chakra-ui/react";
import Link from "next/link";
import { MAIN_ROUTES } from "@/constants/routes";
import { Text } from "@/elements";

const LinkComponent = ({ href, label }: { href: string; label: string }) => {
  return (
    <ChakraLink
      as={Link}
      color="primary.200"
      fontSize={"1.2rem"}
      fontWeight={500}
      href={href}
      textDecor={"underline"}
      textDecorationColor={"#F9AF18"}
      textDecorationThickness={"1px"}
      textUnderlineOffset={"4px"}
    >
      {label}
    </ChakraLink>
  );
};

export const FAQ_LIST = {
  items: [
    {
      title:
        "What are Bare-Metal Servers, and how are they different from virtual servers?",
      content:
        "Bare-Metal Servers provide dedicated physical hardware without the delays and limitations of virtual machine layers, ensuring higher performance, security, and control.",
    },
    {
      title: "Can I customize my Bare-Metal Server’s hardware specifications?",
      content:
        "Yes! You can choose CPU, RAM, NVMe storage, and network configurations to match your specific workload.",
    },
    {
      title: "Are Bare-Metal Servers suitable for virtualization?",
      content:
        "Absolutely! You can install your own hypervisor and create custom VM environments.",
    },
    {
      title: "How quickly can I deploy a Bare-Metal Server?",
      content:
        "Most of them can be deployed instantly but it could take 24 hours -7 days for custom configurations.",
    },
    {
      title: "What industries benefit from Bare-Metal Servers?",
      content:
        "AI, ML, financial services, healthcare, gaming, and data analytics industries require high-performance bare-metal solutions.",
    },
    {
      title: "How does Onemind ensure the security of Bare-Metal Servers?",
      content:
        "Advanced security includes firewalls, encryption, DDoS protection, and compliance with industry standards.",
    },
    {
      title: "What kind of network connectivity do Onemind Bare-Metal Servers offer?",
      content:
        "1Gbps -  100Gbps network speeds, with redundant data center connectivity.",
    },
    {
      title: "Can I upgrade my Bare-Metal Server later?",
      content:
        "Yes! We offer scalable solutions to increase compute, storage, and network capacity as needed.",
    },
    {
      title: "Do you offer managed services for Bare-Metal Servers?",
      content:
        "Yes! We offer Managed and Co-Managed services . We also provide 24/7 monitoring, maintenance, and security services.",
    },
    {
      title: "How do I get started with Onemind’s Bare-Metal Servers?",
      content: (
        <Stack>
          <Text variant={"body2"}>
            Contact our experts for a free consultation and custom server deployment.
          </Text>
          <LinkComponent
            href={MAIN_ROUTES.BOOK_A_CONSULTATION}
            label={"Talk to an Expert"}
          />
        </Stack>
      ),
    },
  ],
};
